export const receiptsEndpoints = {
  createReceipt: { method: 'post', path: '/' },
  getReceiptsByPurchaseOrderId: { method: 'get', path: '/by-purchase-order/{purchaseOrderId}' },
  getReceivingStatusByPurchaseOrderId: { method: 'get', path: '/by-purchase-order/{purchaseOrderId}/receiving-status' },
  voidReceiptLineItem: { method: 'post', path: '/line-items/{receiptLineItemId}/void' },
} as const
